/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const boostParser = new DOMParser();

const customize = {
    updateProductList: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductList', {
            name: 'Trigger Masonry Layout & Wishlist Buttons for Product List',
            enabled: true,
            apply: () => ({
                beforeInit(element) {},
                afterInit(element) {},
                render(elementModel, currentRenderElement) {
                    return currentRenderElement;
                },
                beforeRender(element) {},
                afterRender(element) {
                    // use pure JS here
                    let productsDiv = document.querySelector('.boost-sd__product-list');
                    if (!productsDiv) return;

                    let msnry = new Masonry(productsDiv, {
                        itemSelector: '.boost-sd__product-item',
                        columnWidth: '.boost-sd__product-item',
                        percentPosition: true
                    });
                    setInterval(function() {
                        msnry = new Masonry(productsDiv, {
                            itemSelector: '.boost-sd__product-item',
                            columnWidth: '.boost-sd__product-item',
                            percentPosition: true
                        });
                    }, 1000);

                    if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) ReloadSmartWishlist();
                    // DO NOT DELETE THIS LINE -- const productData = element.getParams().props.product;
                }
            }),
        });
    }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductList]);


// Start Boost 216903
const customProductItem = {
    updateProductItem: (componentRegistry) => {
        /* Start-Boost-230084 */
        let formatMoneyHelper = '';
        componentRegistry.useComponentPlugin('FormatCurrency', {
            name: 'Show Trailing Zeros',
            apply: () => ({
                afterRender: (element) => {
                    try {
                        formatMoneyHelper = element.getHelpers().formatMoney;
                        if (!formatMoneyHelper) return;
                    } catch (e) {
                        console.warn(e);
                    }
                },
            }),
        });
        /* End-Boost-230084 */
      
        componentRegistry.useComponentPlugin("ProductItem", {
            name: "Add Product Metafield on product item #197743",
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        let productData = element.getParams().props.product;
                        let productItem = document.querySelector('[data-product-id="' + productData.id + '"]');
                        let has_editions = false;
                        let total_stock = 0;
                      
                        /* Boost 226999 */
                        let variants = productData.variants;
                        let minPrice = Math.min(...variants.map(variant => parseFloat(variant.price)));
                        let variantsWithMinPrice = variants.filter(variant => parseFloat(variant.price) === minPrice);
                        let smallestPriceVariant = variantsWithMinPrice[0];
                        let smallestPriceVariantId = smallestPriceVariant.id;
                        let productLink = productItem.querySelector(".boost-sd__product-link");
                        let newProductLink = productLink.href + '?variant=' + smallestPriceVariantId + ''
                        productLink.href = newProductLink;
                        /* Boost 226999 */
                      
                        productData.options_with_values.forEach(option => (option.label === 'Edition Nr.') ? has_editions = true : null);

                        if (has_editions) {
                            productData.variants.forEach(variant => total_stock += variant.inventory_quantity);
                        }

                        let metaJhar = productData.metafields.find((meta) => meta.key == "Jhar");
                        let metaGrobe = productData.metafields.find((meta) => meta.key == "Grobe");
                        let metaArtist = productData.metafields.find((meta) => meta.key == "artist");


                        let productStockElement = total_stock > 0 ? `<div class="abz-stock-count">${window.stockString.replace('{{count}}', total_stock)}</div>` : "";
                        let productJhar = metaJhar ? `<div class="boost-sd__product-custom-jhar"> - ${metaJhar.value}</div>` : "";
                        let productGrobe = metaGrobe ? `<div class="boost-sd__product-custom-grobe">${metaGrobe.value} </div>` : "";
                        let productArtist = metaArtist ? `<div class="boost-sd__product-custom-Artist">${metaArtist.value} </div>` : "";
                        let productWishlist = `<span class="boost-sd__product-custom-wishlist smartwishlist" data-product="${productData.id}" data-variant="${productData.variants[0].id}"></span>`;
                        let productBadge = productData.available ? `<new-badge class="abz-new-badge hidden" data-created="${productData.created_at}">NEW</new-badge>` :
                            `<div class="abz-soldout-badge"></div>`;

                        
                        const productHandles = productData.handle;
                        if (productHandles?.length) {
                            let productTitleElement = productItem.querySelector(".boost-sd__product-title");
                            if (!productItem.querySelector(".boost-sd__product-custom-jhar")) productTitleElement.insertAdjacentHTML("beforeend", productJhar);

                            let productInfoElement = productItem.querySelector(".boost-sd__product-info");
                            // let productAddElement = productItem.querySelector(".boost-sd__button");
                            // if (productAddElement) {
                            //   productAddElement.classList.remove('boost-sd__button--show-on-hover')
                            //   productInfoElement.append(productAddElement);
                            // }

                            let productPriceElement = productItem.querySelector(".boost-sd__product-price");
                            if (!productItem.querySelector(".abz-taxes") && productPriceElement) productPriceElement.insertAdjacentHTML("beforeend", window.abzTaxes);

                            /* Start boost 221523 */
                            let soldOutMessage = '<span class="boost-sd-soldout-message">Verkauft um</span>';
                            if (!productItem.querySelector(".boost-sd-soldout-message") && productPriceElement && !productData.available) productPriceElement.insertAdjacentHTML("afterbegin", soldOutMessage);
                            /* End boost 221523 */

                            if (!productItem.querySelector(".abz-stock-count") && productPriceElement) productPriceElement.insertAdjacentHTML("afterBegin", productStockElement);
                            if (!productItem.querySelector(".boost-sd__product-custom-wishlist")) productTitleElement.insertAdjacentHTML("afterend", productWishlist);
                            if (!productItem.querySelector(".boost-sd__product-custom-grobe")) productTitleElement.insertAdjacentHTML("afterend", productGrobe);
                            if (!productItem.querySelector(".boost-sd__product-custom-Artist")) productTitleElement.insertAdjacentHTML("afterend", productArtist);
                            if (!productItem.querySelector(".abz-new-badge") && !productItem.querySelector(".abz-soldout-badge")) productInfoElement.insertAdjacentHTML("beforeend", productBadge);
                        
                            /* Start-Boost-230084 */
                            if (!productData.available && Number(productData.compare_at_price_min) > Number(productData.price_min)) {
                                const priceStyle = 'color: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceColor +
                                                    '; font-size: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceFontSize + 'px' +
                                                    '; font-family: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceFontFamily +
                                                    '; font-weight: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceFontWeight +
                                                    '; font-style: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceFontStyle;
                                let comparePriceHtml = '<span class="boost-sd__format-currency" style="' + priceStyle + '">' +
                                                          '<span class="">' + formatMoneyHelper(Number(productData.compare_at_price_min)) + '</span>' +
                                                        '</span>';
                                productItem.querySelector('.boost-sd__product-price-content').innerHTML = comparePriceHtml;
                                if (productItem.querySelector('.boost-sd__product-price-saving')) productItem.querySelector('.boost-sd__product-price-saving').remove();
                            }
                            /* End-Boost-230084 */
                        }
                    } catch (error) {
                        console.log(error);
                    }

                },
            }),
        });
    },
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    customProductItem.updateProductItem,
]);
// End Boost 216903

// Start Boost 221523
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('FormatCurrency', {
            name: 'Show Trailing Zeros',
            apply: () => ({
                afterRender: (element) => {
                    try {
                        // Start customization--------------------------------------------
                        const formatMoneyHelper = element.getHelpers().formatMoney;
                        if (!formatMoneyHelper) return;
                        const value = element.getParams().props.value; // Get price
                        const customValue = formatMoneyHelper(Number(value), window.boostSDAppConfig?.shop?.money_format, true);

                        if (customValue && element.getRootElm() && element.getRootElm().querySelector('.boost-sd__format-currency span')) {
                            element.getRootElm().querySelector('.boost-sd__format-currency span').innerHTML = customValue;
                        }
                        // End-------------------------------------------------------------
                    } catch (e) {
                        console.warn(e);
                    }
                },
            }),
        });
    }
]);

// End Boost 221523

// if(boostSDAppConfig?.filterSettings) {
//   boostSDAppConfig.filterSettings.filterLayout = 'horizontal';
// }